import { Row } from "react-bootstrap";

import usePermissions from "hooks/usePermissions";
import CardNew from "components/molecules/Card/CardNew";
import CompanyDetailsForm from "./components/CompanyDetails";
import InvoiceSettings from "./components/InvoiceSettings";
import WorkflowSettingsForm from "./components/WorkflowSettings";

const CompanyDetails = function () {
  const { permissions } = usePermissions();
  const { user_type } = JSON.parse(permissions || "{}");

  return (
    <Row className="mb-30 pl-15 d-flex flex-column">
      <div style={{ maxWidth: "848px" }}>
        <CardNew>
          <CompanyDetailsForm />
          {user_type === "shipper" && (
            <>
              <WorkflowSettingsForm />
              <InvoiceSettings />
            </>
          )}
        </CardNew>
      </div>
    </Row>
  );
};

export default CompanyDetails;
